import { makeStyles } from "@mui/styles";

export const FiltrosStyles = makeStyles(() => ({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0.5em",
    },
    filtros: {
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
    },
    inputContainer: {
        position: "relative",
        "& .MuiFormControl-root": {
            flexDirection: "column !important",
            "& .MuiFormHelperText-root": {
                maxWidth: "100% !important",
            }
        }
    },
    input: {
        flexDirection: "row",
        marginRight: "2rem",

        "& .MuiInputBase-root": {
            width: "138px",
        },
    },
    iconoBorrar: {
        height: "16px",
        width: "16px",
        position: "absolute",
        right: "2rem",
        bottom: "16px",
        cursor: "pointer",
    },
    total: {
        margin: 0,
        height: "4rem",
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
        paddingBottom: "6px",
        boxSizing: "border-box",
    },
    marginNormal: {
        height: "48px",
        marginBottom: "8px",
        marginTop: "16px",
        display: "flex",
        alignItems: "flex-end",
    },
    button: {
        width: "100px",
    },
}));
